import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import myBtnMb from "images/my_btn_mb.png";
import Pagenation from "components/Pagenation";
import { apiWrapper } from "apis/CommonApi";
import * as communityApi from "../../apis/CommunityApi";
import { getNoticeBoardSearchTypeName, NoticeBoardSearchType, UserAuthorityChoice } from "utils/common";
import { dateFormat, getDateTime } from "utils/date";
import { useAppContext } from "utils/store";
import { API_HOST } from "Constants";

export default function NoticeBoardPageComponent() {
  const { store: { userAuthority } } = useAppContext();
  const itemsPerPage = 100;
  const pwdRef = useRef(null);
  const [isSearchListOpen, setIsSearchListOpen] = useState(false);
  const [isNoticeWriteModalOpen, setIsNoticeWriteModalOpen] = useState(false);
  const [isNoticeViewModalOpen, setIsNoticeViewModalOpen] = useState(false);
  const [isNoticePwdModalOpen, setIsNoticePwdModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [selectedSearchType, setSelectedSearchType] = useState("1");
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [selectedDataSource, setSelectedDataSource] = useState(null);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setFormDataProperty("author", "");
    setFormDataProperty("contactNumber", "");
    setFormDataProperty("email", "");
    setFormDataProperty("isPublic", "true");
    setFormDataProperty("password", "");
    setFormDataProperty("title", "");
    setFormDataProperty("content", "");
    setFormDataProperty("files", []);
    setFormDataProperty("reply", "");

    getData(1);
  }, []);

  useEffect(() => {
    if (selectedDataSource && selectedDataSource.reply !== null) {
      setFormDataProperty("reply", selectedDataSource.reply);
    } else {
      setFormDataProperty("reply", "");
    }
  }, [selectedDataSource]);

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      let result;
      if (url !== null) {
        result = await communityApi.getBoardListByUrl(url);
      } else {
        result = await communityApi.getBoardList(
          selectedSearchType,
          searchText,
          page,
          itemsPerPage
        );
      }

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    if (e.target.type === 'file') {
      const newFiles = e.target.files;
      if (newFiles.length > 0) {
        setFormDataProperty("files", [...formData.files, ...newFiles]);
      }
    } else {
      let name = e.target.name;
      let value = e.target.value;
      setFormDataProperty(name, value);
    }
  };

  const handleDeleteFile = (e) => {
    setFormDataProperty("files", formData.files.filter(item => item !== e));
  }

  const openNoticeWriteModal = () => {
    setIsNoticeWriteModalOpen(true);
    setTimeout(() => {
      const modalContent = document.querySelector(".modal_content");
      if (modalContent) {
        modalContent.style.transform = "translateX(0)";
      }
    }, 10);
  };

  const openModal = (item) => {
    setSelectedId(item.id);

    if (item.isPublic === false) {
      //비밀번호 입력 모달 열기
      setIsNoticePwdModalOpen(true);
    }
    else {
      openNoticeViewModal(item.id);
    }
  };

  const openNoticeViewModal = (id) => {
    apiWrapper(async () => {
      const result = await communityApi.getBoard(id);

      const { status, data } = result;
      if (status === true) {
        setSelectedDataSource(data);
      } else {
        alert(`${data}`);
      }
    });

    //게시판 상세보기 모달 열기
    setIsNoticeViewModalOpen(true);
    setTimeout(() => {
      const modalContent = document.querySelector(".modal_content");
      if (modalContent) {
        modalContent.style.transform = "translateX(0)";
      }
    }, 10);
  }

  const closeModal = () => {
    const modalContent = document.querySelector(".modal_content");
    if (modalContent) {
      modalContent.style.transform = "translateX(100%)";
    }
    setTimeout(() => {
      setIsNoticeWriteModalOpen(false);
      setIsNoticeViewModalOpen(false);
    }, 500);

    //상세보기 창 닫히면 새로고침
    getData(page);
  };

  const closeNoticePwdModal = () => {
    const noticePwdModal = document.querySelector('.noticePwdModal');
    if (noticePwdModal) {
      setIsNoticePwdModalOpen(false);
    }
  };

  const toggleSelectBox = () => {
    setIsSearchListOpen(!isSearchListOpen);
  };

  const handleSearchItemClick = (type) => {
    setSelectedSearchType(type);
    setIsSearchListOpen(false);
  };

  const handleChangeSearchText = (e) => {
    setSearchText(e.target.value);
  }

  const handleSearch = (e) => {
    if (e.type === "click" || (e.type === "keydown" && e.keyCode === 13)) {
      getData(page);
    }
  }

  const handleSave = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {

      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = new FormData();
        if (formData.files.length > 0) {
          formData.files.map((file) => {
            requestBody.append("files", file);
          });
        }
        requestBody.append("data",
          JSON.stringify({
            author: formData.author,
            contactNumber: formData.contactNumber,
            email: formData.email,
            isPublic: formData.isPublic,
            title: formData.title,
            content: formData.content,
            password: formData.password,
          }));

        const result = await communityApi.createBoard(requestBody);

        const { status, data } = result;
        alert(`${data}`);

        if (status === true) {
          closeModal();

          //성공 시 새로고침
          getData(page);
        }
      });
    }
  }

  const checkValid = () => {
    return true;
  }

  const handlePageArrowClick = (page, isNext) => {
    let url = null;
    if (isNext === false) {
      url = previous;
    } else {
      url = next;
    }

    getData(page, url);
  }

  const handleCheckPwd = () => {
    //비밀번호 확인
    apiWrapper(async () => {
      const requestBody = {
        "password": pwdRef.current.value,
      }
      const result = await communityApi.checkPasswordBoard(selectedId, requestBody);

      const { status, data } = result;
      if (status === true) {
        //비밀번호 일치하면 상세보기
        closeNoticePwdModal();
        openNoticeViewModal(selectedId);
      } else {
        alert(`${data}`);
      }
    });
  }

  const handleSaveReply = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const requestBody = {
          "reply": formData.reply,
        }
        const result = await communityApi.replyBoard(selectedId, requestBody);
        const { status, data } = result;
        alert(`${data}`)

        if (status === true) {
          closeModal();

          //성공 시 새로고침
          getData(1);
        }
      });
    };
  }

  const handleDownload = async (file, originalFilename) => {
    //첨부파일 URL -> Blob 변환
    try {
      const response = await fetch(API_HOST + file);
      if (!response.ok) {
        throw new Error(`${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = originalFilename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("첨부파일 URL을 Blob 객체로 변환 실패 : ", error)
    }
  }

  return (
    <>
      <div class="viewBoard viewDBMSBoard pb-120">
        <div class="top_board pc">
          <p class="title_board">게시판</p>
          <div class="wrap_search openSearch">
            <div class="box_search">
              <div className={`select_box ${isSearchListOpen ? "open" : ""}`}>
                <button className="btn_select" onClick={toggleSelectBox}>
                  <p>{getNoticeBoardSearchTypeName(selectedSearchType)}</p>
                  <i class="x-icon"></i>
                </button>
                <ul class="list_member">
                  {Object.values(NoticeBoardSearchType).map(
                    (item, index) => (
                      <li onClick={() => handleSearchItemClick(item)}>
                        <p>{getNoticeBoardSearchTypeName(item)}</p>
                      </li>
                    )
                  )}
                </ul>
              </div>
              <input
                class=""
                type="text"
                placeholder="검색어를 입력해주세요."
                onChange={handleChangeSearchText}
                onKeyDown={handleSearch}
                defaultValue={searchText}
              />
              <button class="btn_search" onClick={handleSearch}>
                <i class="x-icon icon_search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="top_board mb">
          <div class="wrap_logo">
            {/* <img src="" alt="" class="img_logo"> */}
          </div>
          <div class="header_dept">
            <p class="user">COWORKER</p>
            <div class="wrap_contr">
              <Link class="set_contr" to="">
                <img src={myBtnMb} alt="" />
              </Link>
            </div>
          </div>
        </div>
        <div class="top_board navi_board mb navi_tab_board">
          <Link class="wrap_navi" to="/board/system">
            <p class="title_navi">시스템 공지사항</p>
          </Link>
          <Link class="wrap_navi  now" to="/board/notice">
            <p class="title_navi">게시판</p>
          </Link>
        </div>
        <div class="top_board navi_board top_search_board mb">
          <Link class="wrap_navi " to="/">
            <p class="title_navi">게시판</p>
          </Link>
          <div class="wrap_right wrap_search_right">
            <input type="text" placeholder="검색어를 입력해주세요." />
            <button class="btn_cancle">취소</button>
          </div>
          <div class="wrap_right wrap_icon_right">
            <button class="btn_page_left">
              <i class="x-icon search_icon"></i>
            </button>
          </div>
        </div>

        <div class="table_board  notice_table_board">
          <div class="wrap_table">
            <div class="containerTable noticeTable">
              <ul class="head_table pc">
                <li>
                  <p>순번</p>
                </li>
                <li>
                  <p>제목</p>
                </li>
                <li>
                  <p>작성자</p>
                </li>
                <li>
                  <p>등록 일자</p>
                </li>
                <li>
                  <p>공개</p>
                </li>
                <li>
                  <p>조회</p>
                </li>
              </ul>

              <div class="body_table">
                <div class="inner_table_wrap">
                  {dataSource.results &&
                    dataSource.results.map((item, index) => (
                      <div className={`wrap_table_item ${item.isPublic === true ? '' : 'hide_table_item'}`} onClick={() => openModal(item)}>
                        <div class="inner_dep_wrap wrap-60">
                          <div class="inner_table_item table_item_01 pc">
                            <p class="cont_table_item">{item.id}</p>
                          </div>

                          <div class="inner_table_item table_item_02">
                            <p class="cont_table_item">{item.title}</p>
                            {item.existReply === true ? <p class="answer-badge">답변 OK</p> : null}
                          </div>
                        </div>
                        <div class="inner_dep_wrap wrap-40">
                          <div class="inner_table_item table_item_03">
                            <p class="cont_table_item">{item.author ? (item.author.length < 2 ? item.author : `${item.author.substring(0, 1)}*${item.author.substring(2)}`) : null}</p>
                          </div>
                          <span class="bar mb">|</span>

                          <div class="inner_table_item table_item_04">
                            <p class="cont_table_item">{getDateTime(new Date(item.createdDate))}</p>
                          </div>
                          <span class="bar mb">|</span>

                          <div class="inner_table_item table_item_05 pc">
                            {item.isPublic === true ?
                              <p class="cont_table_item status_item showStatus">공개</p>
                              :
                              <p class="cont_table_item status_item hideStatus">비공개</p>
                            }
                          </div>

                          <div class="inner_table_item table_item_06">
                            <p class="cont_table_item"><i class="x-icon mb"></i>{item.viewsCount}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="wrap_controll type-start">
          <div class="wrap_dbms_btn">
            <button class="item_btn write_btn" onClick={openNoticeWriteModal}>작성</button>
          </div>
          <div id="pagination">
            <Pagenation
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page}
              setPage={(value) => setPage(value)}
              handlePageArrowClick={handlePageArrowClick}
            />
          </div>
        </div>

        {isNoticeWriteModalOpen && (
          <div id="modal" class="modal rightModal noticeRightModal noticeWriteModal open"
            onClick={(e) => {
              if (e.target === e.currentTarget)
                closeModal();
            }}>
            <form class="modal_content N_modal_content" onSubmit={handleSave}>
              <button type="button" class="close_modal" onClick={closeModal}>
                <i class="x-icon close_icon"></i>
              </button>
              <h2>게시판 작성하기</h2>
              <div class="wrap_detail_cont wrap_detail_viewCont">
                <div class="wrap_detail_item">
                  <p class="title_detail">작성자</p>
                  <div class="detail_box">
                    <input type="text" class="detail_input" placeholder="작성자를 입력해주세요" name="author" value={formData.author} onChange={onChange} required />
                  </div>
                </div>
                <div class="wrap_detail_item">
                  <p class="title_detail">연락처</p>
                  <div class="detail_box">
                    <input type="text" class="detail_input" placeholder="연락처를 입력해주세요" name="contactNumber" value={formData.contactNumber} onChange={onChange} required />
                  </div>
                </div>
                <div class="wrap_detail_item">
                  <p class="title_detail">이메일</p>
                  <div class="detail_box">
                    <input type="email" class="detail_input" placeholder="이메일을 입력해주세요" name="email" value={formData.email} onChange={onChange} required />
                  </div>
                </div>
                <div class="wrap_detail_item">
                  <p class="title_detail">내용보안</p>
                  <div class="detail_box detail-duble-box">
                    <div class="wrap_inner wrap_raido_inner ">
                      <label for="radio_1" class="radio-item">
                        <input type="radio" id="radio_1" class="form-radio" name="isPublic" value="true" checked={formData.isPublic === "true"} onChange={onChange} />
                        <span class="radio-icon">
                          <i class="xi-check"></i>
                        </span>
                        <p class="radio-title">공개</p>
                      </label>
                      <label for="radio_2" class="radio-item">
                        <input type="radio" id="radio_2" class="form-radio" name="isPublic" value="false" checked={formData.isPublic === "false"} onChange={onChange} />
                        <span class="radio-icon">
                          <i class="xi-check"></i>
                        </span>
                        <p class="radio-title">비공개</p>
                      </label>
                    </div>
                    {formData.isPublic === "false" &&
                      <input type="password" class="detail_input" placeholder="비밀번호를 입력해주세요" name="password" value={formData.password} onChange={onChange} required />
                    }
                  </div>
                </div>
                <div class="wrap_detail_item">
                  <p class="title_detail">제목</p>
                  <div class="detail_box">
                    <input type="text" class="detail_input" placeholder="제목을 입력해주세요" name="title" value={formData.title} onChange={onChange} required />
                  </div>
                </div>
                <div class="wrap_detail_item">
                  <p class="title_detail">내용</p>
                  <div class="detail_box">
                    <textarea class="detail_textarea" placeholder="내용을 입력해주세요." name="content" onChange={onChange} required >
                      {formData.content}
                    </textarea>
                  </div>
                </div>
                <div class="wrap_detail_item wrap_col_detail_item">
                  <p class="title_detail">첨부파일</p>
                  <div class="modal_upload_wrap">
                    <div class="file-input">
                      <label for="file-upload" class="file-upload-btn">+</label>
                      <input type="file" id="file-upload" class="file-upload-input" name="files" multiple onChange={onChange} />
                    </div>
                    {formData.files.map((item, index) => (
                      <div class="wrap_fileName_btn">
                        <div class="btn_fileDwn">
                          {item.name}
                          <button type="button" class="x-icon btn_icon" onClick={() => handleDeleteFile(item)}>X</button>
                        </div>
                      </div>
                    ))}
                  </div>

                </div>
              </div>
              <div class="wrap_btn_set">
                <button type="submit" class="btn_set btn_save">저장</button>
              </div>
            </form>
          </div>
        )}

        {isNoticeViewModalOpen && (
          <div
            id="modal"
            class="modal rightModal noticeRightModal noticeViewModal open"
            onClick={(e) => {
              if (e.target === e.currentTarget)
                closeModal();
            }}
          >
            <div
              class="modal_content NR_modal_content"
              onClick={(e) => e.stopPropagation()}
            >
              <button type="button" className="close_modal" onClick={closeModal}>
                <i class="x-icon close_icon"></i>
              </button>
              <h2>게시판 상세보기</h2>
              {selectedDataSource && (
                <div class="wrap_detail_cont wrap_detail_viewCont" >
                  <div class="wrap_detail_item">
                    <p class="title_detail">작성자 <span class="bar"></span> 등록일자</p>
                    <div class="detail_box">
                      <p class="writer_detail">{selectedDataSource.author}</p>
                      <span class="bar"></span>
                      <p class="date_detail">{dateFormat(new Date(selectedDataSource.createdDate))}</p>
                    </div>
                  </div>
                  <div class="wrap_detail_item">
                    <p class="title_detail">제목</p>
                    <div class="detail_box">
                      {selectedDataSource.title}
                    </div>
                  </div>
                  <div class="wrap_detail_item">
                    <p class="title_detail">내용</p>
                    <div class="detail_box detail_cont_box">
                      {selectedDataSource.content}
                    </div>
                  </div>
                  <div class="wrap_detail_item">
                    <p class="title_detail">첨부파일</p>
                    {selectedDataSource.attachments.map((item, index) => (
                      <button type="button" class="btn_fileDwn" onClick={() => handleDownload(item.file, item.originalFilename)} >
                        {item.originalFilename}
                        <i class="x-icon btn_icon"></i>
                      </button>
                    ))}
                  </div>
                  {userAuthority === UserAuthorityChoice.ADMIN ? (
                    <form onSubmit={handleSaveReply}>
                      <div class="wrap_detail_item">
                        <p class="title_detail">답변</p>
                        <div class="detail_box">
                          <textarea class="detail_textarea" placeholder="답변 내용을 입력해주세요." name="reply" value={formData.reply} onChange={onChange}>
                          </textarea>
                        </div>
                      </div>
                      <div class="wrap_btn_set">
                        <button type="submit" class="btn_set btn_save">저장</button>
                      </div>
                    </form>
                  ) : (
                    (selectedDataSource.reply !== null &&
                      <div class="wrap_detail_item">
                        <p class="title_detail">답변</p>
                        <div class="detail_box detail_cont_box">
                          {selectedDataSource.reply}
                        </div>
                      </div>
                    )
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {isNoticePwdModalOpen && (
          <div id="modal" class="modal dbmsDelModal noticePwdModal show" >
            <div class="modal-content">
              <div class="modal_inner">
                <p class="modal_title">비공개 게시글</p>
                <input ref={pwdRef} type="text" class="defaultInput" placeholder="게시글의 비밀번호를 입력해주세요." />
                <div class="btn-wrap">
                  <button class="modal_btn cancle_btn" onClick={closeNoticePwdModal}>취소</button>
                  <button class="modal_btn del_btn" onClick={handleCheckPwd}>확인</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div >
    </>
  );
}
